export default __webpack_public_path__ + "static/summarise-illu-daa36c1abe94c6ef5c12ced92b707941.png";